module.exports = __webpack_public_path__ + "assets/images/project/nusajaya-tech-park.jpg?v=9a062936";